import { TranslationKeys } from '.';


export const lang: Record<TranslationKeys, string> = {
    show: 'Visa',
    hide: 'Dölj',
    'content-for': 'innehåll för',
    'submenu-for': 'undermeny för',
    'follow-us-on': 'Följ oss på',
    'written-by': 'Skrivet av',
    'all': 'Alla',
    'load-more': 'Ladda mer',
    'filter-on': 'Filtrera på',
    'minute-read': 'minut läsning',
    'accept-terms': 'Du måste acceptera villkoren',
    'is-required': 'är obligatoriskt',
    'form-sent': 'Formuläret skickades!',
    'form-error': 'Något gick fel, försök igen',
    'captcha-required': 'Bekräfta att du inte är en robot',
    'captcha-failed': 'Verifieringen misslyckades, försök igen',
    'captcha-unavailable': 'Verifieringen kunde inte laddas. Stäng av eventuell annonsblockerare för den här sidan och ladda om.',
    'email-invalid': 'E-post är ogiltig',
    'first-name-invalid': 'Förnamnet är ogiltigt',
    'last-name-invalid': 'Efternamnet är ogiltigt',
    'zip-code-invalid': 'Postnummer är ogiltigt',
    'phone-invalid': 'Telefonnummer är ogiltigt',
    'see-our-projects': 'Se våra projekt',
    'news': 'Nyheter',
    'press': 'Press',
    'close-menu': 'Stäng meny',
    'find-something-good': 'Hitta något bra!',
    'search-hint': 'Sök här...',
    'found': 'Hittade',
    'hits': 'träffar',
    'go-to-homepage': 'Gå till startsidan',
    'twofour-blog-name': 'TwoFour Blogg',
    'twofour-blog-url': 'https://www.twofour.se/blogg',
    'search': 'Sök',
    'show-menu': 'Visa meny',
    'open-search': 'Öppna sök',
    'copy-code-to-clipboard': 'Kopiera koden till clipboard',
    'twofour-slogan': '',
    'post-type-page': 'Sida',
    'post-type-news': 'Nyhet',
    'post-type-blog': 'Blogg',
    'post-type-project': 'Projekt',
    'post-type-client': 'Kund',
    'code-copied-to-clipboard': 'Text kopierad till urklipp!',
    'read-more': 'Läs mer',
    'primary-navigation': 'Huvudnavigation',
    'secondary-navigation': 'Sekundär navigation',
    'no-results': 'Inga resultat',
};
